import { useMutation, type UseMutationOptions } from '@tanstack/react-query';

import { fetchReprocessingInvoiceEmail } from './fetchReprocessingInvoiceEmail';
import { type ReprocessingInvoiceEmailParams } from './types';

/**
 * A custom hook to download an invoice reprocessing email with a given process ID and azure ID.
 * Uses the `useMutation` hook from `@tanstack/react-query` internally.
 *
 * @param options - Optional configuration for the mutation.
 * @returns The mutation result.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Invoice/operation/get_process_mail_invoice_process__process_id__mail__azure_id__get
 */
export const useMutationDownloadReprocessingInvoiceEmail = (
  options?: UseMutationOptions,
) => {
  return useMutation({
    mutationFn: async ({
      azureId,
      processId,
    }: ReprocessingInvoiceEmailParams) =>
      fetchReprocessingInvoiceEmail({
        azureId,
        processId,
      }),
    mutationKey: ['invoiceReprocessing', 'downloadEmail'],
    onError(_error) {
      return; // prevent error from bubbling up further unless overridden via mutation options
    },

    ...options,
  });
};
